import React from 'react';
import Switch from '@rio-cloud/rio-uikit/lib/es/Switch';
import { FormattedMessage } from 'react-intl';

interface DecoupledUpdateFormItemProps {
    value: boolean;
    onChange: (value: boolean) => void;
}

const DecoupledUpdateFormItem: React.FC<DecoupledUpdateFormItemProps> = ({ value, onChange }) => {
    return (
        <div className={'margin-bottom-10 margin-top-10'}>
            <div>
                <label><FormattedMessage id={'intl-msg:decoupledUpdate'}/></label>
            </div>
            <Switch onChange={() => onChange(!value)} checked={value || false}/>
        </div>
    );
};

export default DecoupledUpdateFormItem;
